import { useCurrentUser } from '../../auth/useSession';
import { ErrorState, PageHeader } from '../../components/ui';
import { useMyApplications } from '../../services/applications.service';
import { ApplicationsGrid } from './ApplicationsGrid';

export function ApplicationsPage(): JSX.Element {
  const { data: user } = useCurrentUser();
  const { data: applications, isLoading, isError, refetch } = useMyApplications();

  return (
    <>
      <PageHeader
        title="Aplicaciones"
        description="Aplicaciones del ecosistema a las que tienes acceso."
      />

      {isError ? (
        <ErrorState onRetry={() => void refetch()} />
      ) : (
        <ApplicationsGrid applications={applications} isLoading={isLoading} user={user} />
      )}
    </>
  );
}
